import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Media from './media'
import {
  getWork,
  getMediaKey
} from '../../../../../../stores/works/works.selectors'

const mapStateToProps = (state, { match }) => {
  const currentMedia = getMediaKey(state)
  const work = getWork(state, match.params.workId)
  return {
    media: work.media[currentMedia],
    description: work.description
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(Media)
)
